import { render, staticRenderFns } from "./ModalPoligono.vue?vue&type=template&id=00764a2a&"
import script from "./ModalPoligono.vue?vue&type=script&lang=js&"
export * from "./ModalPoligono.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports